import React, { useState } from 'react';
import { Box, FloatingHelper, Text, TextButton } from '@wix/design-system';
import { Trans, initI18nWithoutICU } from '@wix/wix-i18n-config';
import type { ITraceableTrader } from '@wix/app-market-services';
import { useEssentials } from '../../contexts/essentials-context';
import { TraceableTraderPopoverContent } from './traceable-trader-popover-content';

export function TraceableTrader(traceableTrader: ITraceableTrader) {
  const { languageCode, t } = useEssentials();
  const [i18n] = useState(() =>
    initI18nWithoutICU({ locale: languageCode, messages: {} }),
  );

  return (
    <Box
      dataHook="traceable-trader-disclaimer"
      width="100%"
      direction="vertical"
    >
      <Text secondary size="tiny" lineHeight="tiny">
        <Trans
          t={t}
          i18n={i18n}
          i18nKey="app-page.traceable-trader-line"
          values={{ companyName: traceableTrader.name }}
          components={{
            linkbutton: <LinkButton traceableTrader={traceableTrader} />,
          }}
        />
      </Text>
    </Box>
  );
}

function LinkButton({
  children,
  traceableTrader,
}: {
  children?: React.ReactNode;
  traceableTrader: ITraceableTrader;
}) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { t } = useEssentials();

  return (
    <FloatingHelper
      dataHook="traceable-trader-floating-helper"
      zIndex={9999}
      opened={isPopoverOpen}
      onClose={() => setIsPopoverOpen(false)}
      appearance="light"
      target={
        <TextButton
          dataHook="traceable-trader-disclaimer-link"
          size="tiny"
          underline="always"
          skin="dark"
          onClick={() => {
            setIsPopoverOpen(!isPopoverOpen);
          }}
        >
          {children}
        </TextButton>
      }
      content={
        <FloatingHelper.Content
          title={t('app-page.traceable-trader.popover-title')}
          body={<TraceableTraderPopoverContent {...traceableTrader} />}
        />
      }
      placement="right"
    />
  );
}
